import { Deserializable } from '../../protocols/deserializable';
import { NewEmployerSubmissionData } from './new-employer-submission-data';

export class NewEmployerSubmission implements Deserializable {
  public new!: NewEmployerSubmissionData;

  public onDeserialize() {
    if (!!this.new) {
      this.new = window.injector.Deserialize.instanceOf(NewEmployerSubmissionData, this.new);
    }
  }
}
